module.exports = __webpack_public_path__ + "static/media/netflix.7a07eca6.gif";